// 渲染音频文件和共享
import React, { memo, useState, useEffect } from 'react'
import styled from 'styled-components'
import ScreenSharing from "@/img/screen-sharing.png";
import PhoneImg from "@/img/phone.png";
import DownloadImg from "@/img/download-img-color.png";
import MoreBottom from "@/img/more-bottom.png";
import MoreTop from "@/img/more-top.png";

const VoiceCallMsgOrd = styled.span`
  display: inline-block;
  margin-top: 8px;
  padding: 16px;
  background: #E9E9E9;
  border-radius: 8px;
  color: #595959;

  .top-div{
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0px;
    }

    img{
      width: 16px;
      height: 16px;
      cursor: pointer;
    }

    span{
      margin: 0 8px;
    }
  }

  .content-div{
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    position: relative;
    padding-right: 80px;

    &:last-child {
      margin-bottom: 0px;
    }

    .title-img{
      width: 16px;
      height: 16px;
      cursor: pointer;
    }

    .content-text{
      margin: 0 8px;

      span{
        color: #FC8352;
        margin-right: 8px;
      }
    }
  }

  .packup-div{
    font-size: 12px;
    color: #FC8352;
    position: absolute;
    right: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    
    .small-img{
      width: 8px;
      height: 8px;
      margin-left: 8px;
    }
  }
`

const RenderVoiceCallMsg = memo((props) => {
  const { value } = props
  const [message, setMessage] = useState({})

  //将秒换算成时和分
  const formateSeconds = (endTime) => {
    let secondTime = parseInt(endTime)//将传入的秒的值转化为Number
    let min = 0// 初始化分
    let h = 0// 初始化小时
    let result = ''
    if (secondTime > 60) {//如果秒数大于60，将秒数转换成整数
      min = parseInt(secondTime / 60)//获取分钟，除以60取整数，得到整数分钟
      secondTime = parseInt(secondTime % 60)//获取秒数，秒数取佘，得到整数秒数
      if (min > 60) {//如果分钟大于60，将分钟转换成小时
        h = parseInt(min / 60)//获取小时，获取分钟除以60，得到整数小时
        min = parseInt(min % 60) //获取小时后取佘的分，获取分钟除以60取佘的分
      }
    }
    result = `${h.toString().padStart(2, '0')}:${min.toString().padStart(2, '0')}:${secondTime.toString().padStart(2, '0')}`
    return result
  }

  // 下载
  const downloadImg = (url, name) => {
    name = name || url;
    // fetch抓取图片数据
    fetch(url)
      .then((response) => {
        if (response.status === 200)
          // 返回的.blob()为promise，然后生成了blob对象，此方法获得的blob对象包含了数据类型，十分方便
          return response.blob();
        throw new Error(`status: ${response.status}.`);
      })
      .then((blob) => {
        // 获取到blob对象
        downloadFile(name, blob);
      })
      .catch(() => { });
    function downloadFile(fileName) {
      const anchor = document.createElement("a");
      // 创建指向blob对象地址
      anchor.href = fileName;
      document.body.appendChild(anchor);
      anchor.click();
    }
  };

  useEffect(() => {
    let arr = value.messageContent ? JSON.parse(value.messageContent) : {}
    if (arr.shareData && arr.shareData.length > 0) {
      arr.arr1 = []
      arr.arr1.push(arr.shareData[0])
      arr.arr2 = []
      for (let index = 1; index < arr.shareData.length; index++) {
        const element = arr.shareData[index];
        arr.arr2.push(element)
      }
    } else {
      arr.arr1 = arr.shareData
      arr.arr2 = []
    }
    setMessage(arr)
  }, [])

  return (
    <VoiceCallMsgOrd
      style={value.sendType === 2 ? { background: "rgba(82, 196, 26, 0.1)" } : {}}
    >
      <div className="top-div">
        <img src={PhoneImg} alt="" />
        <span>
          通话时长 {formateSeconds(message.playLength)}
        </span>
        <img src={DownloadImg} alt="" onClick={() => {
          downloadImg(message.url);
        }} />
      </div>
      {
        message.arr1 && message.arr1.map((res, index) => (
          <div className="content-div" key={index}>
            <img src={ScreenSharing} alt="" className="title-img" />

            <div className="content-text">
              {res.name}共享{res.type === "file" ? "文档" : "屏幕"}时长 {formateSeconds(res.playLength)}
              {res.type === "file" ? " 共享文件" : ""}{res.filename && <span>{res.filename}</span>}
              {
                res.filename ?
                  <img src={DownloadImg} className="title-img" onClick={() => {
                    downloadImg(res.url);
                  }} /> : ""
              }
            </div>

            {
              index === 0 && message.canExpand ?
                <div className="packup-div" onClick={() => {
                  setMessage({ ...message, canExpand: false })
                }}>
                  展开
                  <img src={MoreBottom} className="small-img" />
                </div>
                : ""
            }
          </div>
        ))
      }

      {
        !message.canExpand && message.arr2 && message.arr2.map((res, index) => (
          <div className="content-div" key={index}>
            <img src={ScreenSharing} alt="" className="title-img" />

            <div className="content-text">
              {res.name}共享{res.type === "file" ? "文档" : "屏幕"}时长 {formateSeconds(res.playLength)}
              {res.type === "file" ? " 共享文件" : ""}{res.filename && <span>{res.filename}</span>}
              {
                res.filename ?
                  <img src={DownloadImg} className="title-img" onClick={() => {
                    downloadImg(res.url);
                  }} /> : ""
              }
            </div>
            {
              index === message.arr2.length - 1 ?
                <div className="packup-div" onClick={() => {
                  setMessage({ ...message, canExpand: true })
                }} >
                  收起
                  <img src={MoreTop} className="small-img" />
                </div>
                : ""
            }
          </div>
        ))
      }
    </VoiceCallMsgOrd>
  )
})

export default RenderVoiceCallMsg
